// Third-party Library
import React from "react";
import { CheckOutlined } from "@ant-design/icons";

// Styles
import styles from './index.module.css'

const SimpleColorPicker = ({ value = "", onChange = () => {} }) => {

    const colorOptions = [ "magenta", "pink", "blue", "green", "orange", "purple", "cyan" ];

    return (
        <div className={styles['container']}>
            {colorOptions.map((color) => (
                <div
                    key={color}
                    aria-hidden="true"
                    onClick={() => onChange?.(color)}
                    className={styles['color-picker']}
                    style={{
                        border: `2px solid ${color}`,
                        backgroundColor: value === color ? color : "transparent",
                    }}
                >
                    { value === color && <CheckOutlined style={{ color: "#fff" }} /> }
                </div>
            ))}
        </div>
    );
};

export default SimpleColorPicker
